module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/fr-249f606095f98597cc76bd30f2b54c25.png";